import React from 'react';
import { cn } from '../../lib/utils';
import { ArrowUpRight } from 'lucide-react';

export default function StatCard({ 
  title, 
  value, 
  icon: Icon, 
  description, 
  trend,
  variant = 'default',
  className,
  onClick
}) {
  const isPositive = typeof trend === 'string' && trend.startsWith('+');
  const isInteractive = !!onClick;
  
  return (
    <div 
      onClick={onClick}
      className={cn(
        "p-6 bg-card rounded-3xl border border-border shadow-sm group transition-all duration-300",
        isInteractive ? "cursor-pointer hover:border-primary/40 hover:shadow-md hover:translate-y-[-1px] active:translate-y-[0px]" : "",
        className
    )}>
      <div className="flex justify-between items-start mb-4">
        <div className={cn(
          "p-3 rounded-2xl shadow-sm border transition-colors",
          variant === 'primary' ? "bg-primary/10 text-primary border-primary/20" :
          variant === 'success' ? "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" :
          variant === 'warning' ? "bg-amber-500/10 text-amber-500 border-amber-500/20" :
          variant === 'danger' ? "bg-red-500/10 text-red-500 border-red-500/20" :
          "bg-muted/50 text-muted-foreground border-border/50 group-hover:bg-primary/5 group-hover:text-primary group-hover:border-primary/10"
        )}>
          {Icon && <Icon className="w-5 h-5" />}
        </div>
        <div className="flex items-center gap-2">
          {trend && (
            <span className={cn(
              "text-[10px] font-black tracking-widest px-2 py-0.5 rounded-lg border",
              isPositive ? "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" : "bg-red-500/10 text-red-500 border-red-500/20"
            )}>
              {trend}
            </span>
          )}
          {isInteractive && (
            <ArrowUpRight className="w-3.5 h-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 group-hover:text-primary transition-all" />
          )}
        </div>
      </div>
      
      <div>
        <p className="text-[10px] font-black text-muted-foreground uppercase tracking-widest mb-1 opacity-70 group-hover:opacity-100 transition-opacity">
          {title}
        </p>
        <h3 className="text-3xl font-black tracking-tight text-foreground truncate">
          {value}
        </h3>
        {description && (
          <p className="text-[11px] text-muted-foreground mt-1.5 font-semibold line-clamp-1">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}
